/* eslint-disable @typescript-eslint/no-shadow */
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import * as dayjs from 'dayjs';
import {
  MenuItemCatalog,
  MenuItemCatalogGroup,
  MenuItemCatalogPrice,
} from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { changeTimezone } from 'src/app/pipes/change-timezone.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { ReservationStateService } from '../../restaurant-booking/state/reservation-state.service';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss'],
})
export class CatalogComponent implements OnInit {
  @Input() disablePeopleSelector: boolean;

  catalogs: MenuItemCatalogGroup[] = [];
  groupCounters: { [key: string]: number } = {};
  mainGroups: {
    [key: string]: { name: string; groups: MenuItemCatalogGroup[] };
  } = {};
  selectedMainGroup: MenuItemCatalogGroup[] = null;

  isLimited = false;
  isSelected = false;

  processing = false;
  showMore: boolean[] = [];

  userLang: string;

  constructor(
    public dataServ: DataService,
    public cartServ: CartService,
    private changeDetector: ChangeDetectorRef,
    private analyticsServ: AnalyticsService,
    private caption: CaptionPipe,
    private modalServ: ModalMakerService,
    public authServ: AuthService,
    private reservationState: ReservationStateService
  ) {}

  ngOnInit() {
    if (this.dataServ.menuSection && this.dataServ.menuItem) {
      if (
        this.dataServ.menuSection.catalogue_active &&
        this.dataServ.menuItem.menu_item_catalog_groups &&
        this.dataServ.menuItem.menu_item_catalog_groups.length > 0
      ) {
        this.catalogs = JSON.parse(
          JSON.stringify(this.dataServ.menuItem.menu_item_catalog_groups)
        );

        if (this.catalogs.length === 1) {
          this.showMore[0] = true;
        }

        this.dataServ.menuItem.menu_item_catalog_groups.forEach((group) => {
          if (group.menu_item_catalogs) {
            group.menu_item_catalogs.forEach((catalog) => {
              if (catalog.menu_item_catalog_prices) {
                catalog.menu_item_catalog_prices.map(
                  (price) => (price.quantity = 0)
                );
              }
            });
          }

          if (group.max_per_person && group.max_per_person > 0) {
            this.isLimited = true;
          }

          if (group.main_group) {
            this.mainGroups[group.main_group] ||= {
              name: group.main_group,
              groups: [],
            };
            this.mainGroups[group.main_group].groups.push(group);
          }
        });

        if (Object.keys(this.mainGroups).length > 0) {
          this.selectedMainGroup =
            this.mainGroups[Object.keys(this.mainGroups)[0]].groups;

          setTimeout(() => {
            const el = document.getElementById(`main-0`);
            el.scrollIntoView();
          }, 1000);
        }

        this.catalogs.map((group) => {
          if (group.menu_item_catalogs) {
            if (group.service_start_time && group.service_end_time) {
              const START_HOUR = group.service_start_time;
              const END_HOUR = group.service_end_time;

              const NOW_DATE = new Date();

              const [startHours, startMinutes] = START_HOUR.split(':');
              const START_DATE = new Date(
                NOW_DATE.getFullYear(),
                NOW_DATE.getMonth(),
                NOW_DATE.getDate(),
                parseInt(startHours, 10),
                parseInt(startMinutes, 10),
                0,
                0
              );

              const [endHours, endMinutes] = END_HOUR.split(':');
              const END_DATE = new Date(
                NOW_DATE.getFullYear(),
                NOW_DATE.getMonth(),
                NOW_DATE.getDate(),
                parseInt(endHours, 10),
                parseInt(endMinutes, 10),
                0,
                0
              );

              if (START_DATE && END_DATE) {
                const TODAY_DATE = new Date();
                const TODAY_MODIFIED1 = dayjs.utc(new Date()).format();
                const TODAY_MODIFIED2 = new changeTimezone().transform(
                  TODAY_MODIFIED1,
                  this.dataServ.rData.time_zone
                );
                const [todayHours, todayMinutes] = TODAY_MODIFIED2.split(':');
                const NOW_DATE = new Date(
                  TODAY_DATE.getFullYear(),
                  TODAY_DATE.getMonth(),
                  TODAY_DATE.getDate(),
                  parseInt(todayHours, 10),
                  parseInt(todayMinutes, 10),
                  0,
                  0
                );

                if (NOW_DATE < START_DATE || NOW_DATE > END_DATE) {
                  group.is_closed = true;
                }
              }
            }

            group.menu_item_catalogs.forEach((catalog) => {
              catalog.menu_item_catalog_prices?.map((price) => {
                price.quantity ||= 0;
              });
            });
          }
        });
      }
    }

    this.userLang = localStorage.getItem('userLang');

    if (this.disablePeopleSelector) {
      this.isSelected = true;
    }
  }

  getCartItemById(size: MenuItemCatalogPrice) {
    return this.cartServ.cart.find((item) => item.size.id === size.id);
  }

  analytic(
    catalogItem: MenuItemCatalog,
    size: MenuItemCatalogPrice,
    type: 'add' | 'remove'
  ) {
    this.analyticsServ.eventEmitter(
      `${this.caption.transform(
        catalogItem.name,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${this.caption.transform(
        size.size,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${type}_cart`,
      'cart',
      'click',
      `${this.caption.transform(
        catalogItem.name,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${this.caption.transform(
        size.size,
        this.dataServ.rData.hotel_language || 'tr'
      )}_${type}_cart`
    );
  }

  openCatalogItemDetail(
    catalogItem: MenuItemCatalog,
    price: MenuItemCatalogPrice
  ) {
    this.modalServ.openCatalogItemDetail(catalogItem, price);
  }
  cartUpdate(catalogItem: MenuItemCatalog, size: MenuItemCatalogPrice) {
    this.processing = true;
    this.changeDetector.detectChanges();
    const EXIST = this.cartServ.cart.findIndex((x) => x.size.id === size.id);

    if (EXIST >= 0) {
      this.cartServ.cart[EXIST].size = size;
    } else {
      this.cartServ.cart.push({
        item: this.dataServ.menuItem,
        product: catalogItem,
        size,
        note: '',
        basePrice:
          size.activate_offer && !this.dataServ.rData.discount_for_only_member
            ? size.offer_price
            : size.activate_offer &&
              this.dataServ.rData.discount_for_only_member &&
              !this.authServ.isLogged
            ? size.price
            : this.dataServ.rData.general_discount_percentage
            ? size.price -
              (size.price * this.dataServ.rData.general_discount_percentage) /
                100
            : this.dataServ.rData.discount_for_only_member &&
              !this.authServ.isLogged
            ? size.price
            : size.price,
      });
    }

    this.cartServ.calcTotal();
    if (this.dataServ.menuItem.fix_menu) {
      this.reservationState.calculateTotalPrice(
        this.reservationState.reservationData$.value,
        this.reservationState.selectedProgram$.value
      );
      this.reservationState.calculateOriginalTotalPrice(
        this.reservationState.reservationData$.value,
        this.reservationState.selectedProgram$.value
      );
    }
    this.processing = false;
    this.changeDetector.detectChanges();
  }
}
